import { useMemo } from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './Button.module.scss';

const cx = classnames.bind(styles);

const Button = ({
  className,
  disabled,
  tag,
  size,
  theme,
  color,
  children,
  type,
  ...props
}) => {
  const isColorApplied = theme !== 'link'
  const isSizeApplied = theme !== 'link'

  const Tag = useMemo(function () {
    return tag ? tag : (props.href ? 'a' : 'button')
  }, [props.href, tag]);

  const buttonType = useMemo(function () {
    return type ? type : (Tag === 'button' ? 'button' : null)
  }, [type, Tag])

  return (
    <Tag
      className={cx(
        'root',
        className,
        `theme-${theme}`,
        {
          disabled,
          [`color-${color}`]: isColorApplied,
          [`size-${size}`]: isSizeApplied
        }
      )}
      type={buttonType}
      {...props}
    >
      {children}
    </Tag>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  theme: PropTypes.oneOf([
    'rounded',
    'squared',
    'link' // Button color and size props - ignored
  ]),
  color: PropTypes.oneOf([
    'main',
    'main-reverse',
    'secondary',
    'white',
    'white-reverse',
    'black',
    'black-reverse'
  ])
}

Button.defaultProps = {
  className: '',
  tag: null,
  type: null,
  size: 'md',
  theme: 'rounded',
  color: 'main'
}

export default Button;
